// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./svg/co.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./svg/ve.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./svg/ar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flag-co {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  display: block;
}

.flag-ve {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  display: block;
}

.flag-ar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/assets/flags/index.css"],"names":[],"mappings":"AAAA;EACI,yDAAqC;EACrC,4BAA4B;EAC5B,cAAc;AAClB;;AAEA;EACI,yDAAqC;EACrC,4BAA4B;EAC5B,cAAc;AAClB;;AAEA;EACI,yDAAqC;EACrC,4BAA4B;EAC5B,cAAc;AAClB","sourcesContent":[".flag-co {\n    background-image: url(\"./svg/co.svg\");\n    background-repeat: no-repeat;\n    display: block;\n}\n\n.flag-ve {\n    background-image: url(\"./svg/ve.svg\");\n    background-repeat: no-repeat;\n    display: block;\n}\n\n.flag-ar {\n    background-image: url(\"./svg/ar.svg\");\n    background-repeat: no-repeat;\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
